
<template>
  <div class="error-content">
    <div class="error-content__title">
      {{ $t('Errors.IdentificationFailed') }}
    </div>
    <div class="mt-5 text-left h4-headline">
      {{ $t('Errors.IdentificationFailedText') }}
      <div
        v-for="(i, n) in new Array(2)"
        :key="n"
        class="flex my-2">
        <sIcon
          class="my-auto"
          size="8"
          type="dot"/>
        <div class="ml-2 h7-text black--text">
          {{ $t('Errors.IdentificationFailedText' + (+n + 1)) }}
        </div>
      </div>
      {{ $t('Errors.IdentificationFailedChooseBtn') }}
    </div>
    <div class="error-content_btns">
      <CreateInvoiceDialog
        class="error-content_btn"
        data-qa="identification-error-create-invoice-btn"
        mode="black-button"/>
      <sButton
        class="error-content_btn"
        :href="company_link">
        {{ $t('Errors.DownloadCEPUEP') }}
      </sButton>
    </div>
  </div>
</template>
<script>
import CreateInvoiceDialog from 'components/billing/CreateInvoiceDialog.vue'

export default {
  name: 'identificationError',
  computed: {
    company_link() {
      return this.$t('User.CompanyProfileLink',
        { domen: window.config?.SmarttenderUrl })
    },
  },
  components: {
    CreateInvoiceDialog
  }
}
</script>
<style lang="scss" scoped>
.error-content {
  &__title {
    text-align: left;
    margin-left: 16px;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    @media (max-width:935px) {
      margin-left: 0;
      text-align: center;
    }
  }
  &_btns {
    margin-left: 16px;
    margin-top: 16px;
    display: flex;
    @media (max-width:935px) {
      display: grid;
      row-gap: 20px;
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: 100%;
      width: 300px;
    }
  }
  &_btn {
    margin-left: 20px;
    &:nth-child(1) {
      margin-left: 0px;
    }
    @media (max-width:935px) {
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: 100%;
      width: 300px;
    }
  }
}
</style>
